import React, { useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { emiDetails, stageSubmit, setSubStage } from '../../../../slices/eligibility/eligibilitySlice';
import Loader from '../../../common/Loader';
import { toast } from 'react-toastify';

function EmiPlans() {

    const { summaryData } = useSelector(state => state?.eligibility)
    const [margin, setMargin] = useState(+summaryData?.min_margin_money || 0);
    const [disable, setDisable] = useState(false);
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const href = "#";

    const urlParams = new URLSearchParams(window.location.search);
    const referenceId = urlParams.get('referenceId');

    const getEmiData = async () => {
        setLoader(true)
        const response = await dispatch(emiDetails({
            "reference_id": referenceId,
            "voluntary_margin_money": margin
        })).unwrap();
        setLoader(false)
        if (response?.response_code === 'S100') {
            setDisable(false)
        } else {
            !response?.payload?.error &&
            toast.error(response?.response_string || "Something went wrong", {
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        }
    }

    const handleSliderChange = (e) => {
        const value = Math.round(+e.target.value / 100) * 100;
        setMargin(value);
    };

    const handleInputChange = (e) => {
        const rawValue = e.target.value.replace(/\D/g, ''); // Remove non-digits
        const numericValue = +rawValue;

        // Optional: clamp between min and max
        const clampedValue = Math.min(
            Math.max(numericValue, +summaryData?.min_margin_money),
            +summaryData?.max_margin_money
        );

        setMargin(clampedValue);
    };


    const handleProceed = async () => {
        try {
            dispatch(setSubStage("addon"));
            await dispatch(stageSubmit({
                reference_id: referenceId,
                sub_stage: "addon"
            })).unwrap();
        } catch (error) {
            toast.error(error?.message || "Something went wrong", {
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        }
    };

    return (
        <>
            {loader === true && <Loader />}
            <div className="col-md-9 col-sm-12 Side-bank-Right emi-height">
                <div className=" mb-1  static-tab">
                    <div
                        className="d-flex justify-content-between"
                        role="button"
                        tabIndex={0}
                        onClick={() => dispatch(setSubStage("scheme"))}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                dispatch(setSubStage("scheme"));
                            }
                        }}
                    >
                        <p className=" Pname-i text-decoration-none dark-blue small">..  <span className="icon-arrowright-L1 text-decoration-none dark-blue small"></span> Scheme Details <span className="icon-arrowright-L1"></span> <a href={href} className="text-decoration-none dark-blue"> EMI Details</a></p>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Product Price <span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.product_cost).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Margin Money<span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.total_margin_money).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Finance Amount <span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.revised_finance_amount).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Tenure <span className="dark-blue fw-semibold">{summaryData?.total_tenure}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Initial Installments<span className="dark-blue fw-semibold">{summaryData?.advance_emi_tenure}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Net Tenure<span className="dark-blue fw-semibold">{summaryData?.net_tenure}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12 d-none">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Approved Loan Amount<span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.approval_amount).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">EMI<span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.emi_amt).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Amount of Initial Installments<span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.advance_emi_amount).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Total Interest Payable<span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.total_interest_payable).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Interest Payable at Disbursement<span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.interest_at_disbursement).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Admin and Processing Fee<span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.processing_fee).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Down Payment<span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.total_down_payment).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between custom-bg">Dealer Subvention<span className="dark-blue fw-semibold"><span className="font-serif mx-1">₹</span>{Number(summaryData?.dbd_amt).toLocaleString('en-IN')}</span></p>
                    </div>
                    <div className="col-12 col-lg-12 col-md-12">
                        <p className="text-secondary d-flex justify-content-between bg-purple-txt custom-bg mb-0 fw-bold">Final Disbursement Amount<span className="dark-blue fw-semibold bg-purple-txt"><span className="font-serif mx-1">₹</span>{Number(summaryData?.final_disbusement).toLocaleString('en-IN')}</span></p>
                    </div>
                </div>
                {summaryData?.scheme_type !== 'fixed' && 
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-between custom-border-top">
                            <label className="form-label fw-bold text-secondary mt-4" htmlFor="money">
                                Voluntary Margin Money
                            </label>
                            <div className="input-group lakh-input-group mt-4">
                                <span className="input-group-text">₹</span>
                                <input
                                    type="text"
                                    className="form-control py-1 small"
                                    value={Number(margin).toLocaleString('en-IN')} // use formatted value for typing
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                        <div className="mt-4">
                            <input
                                type="range"
                                min={+summaryData?.min_margin_money}
                                max={+summaryData?.max_margin_money}
                                step="500" // ✅ Allow only 500's
                                value={margin}
                                onChange={handleSliderChange}
                                className="form-control-range range-slider"
                                id="myRange"
                            />
                            <div className="range-values d-flex justify-content-between">
                                <span className="small fw-semibold">
                                    <span className="font-serif mx-1">₹</span>{Number(summaryData?.min_margin_money).toLocaleString('en-IN')}
                                </span>
                                <span className="small fw-semibold">
                                    <span className="font-serif mx-1">₹</span>{Number(summaryData?.max_margin_money).toLocaleString('en-IN')}
                                </span>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end mt-3 mb-3">
                            <button
                                className="btn btn-outline-primary calculate-btn"
                                type="button"
                                onClick={() => { getEmiData() }}
                            >
                                Calculate
                            </button>
                        </div>
                    </div>
                </div>}
            </div>
            <footer className="sticky-bottom-1">
                <div className="container-fluid ">
                    <div className="row">
                        <div className="col-sm-12 ">
                            <div className="d-flex justify-content-between">
                                <button className="btn btn-outline-primary " type="button" onClick={() => { dispatch(setSubStage("scheme")) }}>Change Scheme</button>
                                <button className="btn btn-primary" type="button" onClick={handleProceed} disabled={disable}>Proceed</button>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default EmiPlans